import React from 'react'

import {
  StyledRadioCircle,
  StyledRadioContainer,
  StyledRadioInput,
  StyledRadioSubLabel,
  StyledRadioSubContainer,
  StyledRadioLabel,
} from './styles'

import { twicePerWeekIcon, oncePerWeekIcon, oncePerMonthIcon, outOfNewsletterIcon } from '../../assets/cdn'

const InputRadio = ({ id, value, onChange, label, subLabel, iconType, handleChange, handleCheck, isChecked }) => {
  const radioInputValues = {
    value1: '2x per week',
    value2: '1x per week',
    value3: '1x per month',
    value4: 'Out of newsletter'
  }
  const setImg = (url, text) => { return <img src={url} alt={text} /> }

  function getIcon(id) {
    if (id === 0) {
      return setImg(twicePerWeekIcon, 'Twice Per Week Icon')
    }
    else if (id === 1) {
      return setImg(oncePerWeekIcon, 'Once Per Week Icon')
    }
    else if (id === 2) {
      return setImg(oncePerMonthIcon, 'Once Per Month Icon')
    }
    else if (id === 3) {
      return setImg(outOfNewsletterIcon, 'Out Of Newsletter Icon')
    }
    else {
      return;
    }
  }

  function getValue(index) {
    return index === 0 ? radioInputValues.value1
      : index === 1 ? radioInputValues.value2
        : index === 2 ? radioInputValues.value3
          : radioInputValues.value4;
  }

  return (
    <>
      <StyledRadioInput
        type="radio"
        name="radio"
        id={id}
        onChange={onChange}
        value={getValue(value)}
        checked={isChecked === getValue(value)}
      />

      <StyledRadioContainer htmlFor={id}>
        <StyledRadioSubContainer>
          <StyledRadioCircle />
          <StyledRadioLabel isChecked={isChecked === getValue(value)}>
            {label}
          </StyledRadioLabel>
        </StyledRadioSubContainer>
        {
          subLabel &&
          <StyledRadioSubLabel>
            {subLabel}
          </StyledRadioSubLabel>
        }
        {getIcon(iconType)}
      </StyledRadioContainer>
    </>
  )
}

export default InputRadio
